import { APP_PERMISSIONS } from '@exam-management/permissions';
import { Navigate, useParams } from '@exam-management/router';
import { usePermission } from '@shared/permissions';

export default function ExamCourseDetailsPage() {
  const { courseId } = useParams('/exam-courses/:courseId');
  const { permissions } = usePermission();

  if (permissions.includes(APP_PERMISSIONS.EXAM.QCONFIG.VIEW)) {
    return <Navigate to='/exam-courses/:courseId/qconfigs' params={{ courseId }} replace />;
  } else if (permissions.includes(APP_PERMISSIONS.EXAM.QSET.VIEW)) {
    return <Navigate to='/exam-courses/:courseId/qsets' params={{ courseId }} replace />;
  }

  return <Navigate to='/exam-courses' replace />;
}
